/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React,{useRef, useState} from 'react'
import { useOnClickOutside } from '../../CommonMethods/OutsideClick'

// `text` overrides the popover copy and `contentClassName` overrides its positioning/size;
// both default to the original GST behaviour so existing usages are unchanged. The label only
// renders when `name` is passed (lets callers use just the (i) icon next to their own label).
export default function ToolTip({name,id,text,contentClassName}) {
    const ref =useRef()
    const [show, setshow] = useState(false)
    useOnClickOutside(ref,()=>{
        setshow(false)

    })
    return (


        <div
            ref={ref}

            className={`relative flex items-center ${name ? 'pb-1.5' : ''}`}
        >
            {name && <label htmlFor="uploadGST" className="text-f1 font-medium text-[#344054] ">{name}</label>}
            <div className="relative h-4">
                <button
                    onClick={()=>setshow(!show)}
                    data-tooltip-target="gstuploadInfo" data-tooltip-trigger="click"  data-tooltip-placement="top" type="button" className="ml-[5px] h-4">
                    {/* Inline info-circle — /images/InfoIcon.svg doesn't exist in this app's public assets */}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="info">
                        <circle cx="12" cy="12" r="10" stroke="#667085" strokeWidth="2" />
                        <path d="M12 16v-4" stroke="#667085" strokeWidth="2" strokeLinecap="round" />
                        <circle cx="12" cy="8" r="1.25" fill="#667085" />
                    </svg>
                </button>
                <motion.div
                    id="gstuploadInfo"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0 }}
                    role="tooltip"
                    className={`${show?'visible':'invisible'} ${contentClassName || 'absolute left-[28px] bottom-[-3px] w-max z-10 inline-block left-[117px] text-[10px] leading-[18px] font-normal text-[#031624] px-1.5 py-1 bg-[#E6E8EA] rounded-[5px]'}`}
                >
                    {/* Caret only for custom-text tooltips (they open below the icon); GST default keeps its side placement */}
                    {text && <div className="absolute -top-[5px] left-1/2 -translate-x-1/2 h-2.5 w-2.5 rotate-45 bg-inherit border-t border-l border-[#E6E8EA]"></div>}
                    {text || 'Upload a JPEG,PNG or PDF File with a Maximum Size of 10 MB'}
                    <div className="tooltip-arrow" data-popper-arrow></div>
                </motion.div>
            </div>
        </div>
    )
}
